(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cartune-credit-shop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cartune-credit-catalog]');
    if (!root) return;
    const source = root.querySelector('[data-cartune-credit-source]');
    const groups = root.querySelector('[data-cartune-credit-groups]');
    const cards = Array.from(root.querySelectorAll('[data-cartune-credit-product]'));
    const originalOrder = new Map(cards.map((card, index) => [card, index]));

    const normalize = (value) => {
      const match = String(value ?? '').match(/^\d+/);
      return match ? match[0].replace(/^0+(?=\d)/, '') : '0';
    };
    const enough = (balance, cost) => {
      try { return BigInt(balance) >= BigInt(cost); } catch { return false; }
    };

    const groupFor = (card, balance) => {
      if (card.dataset.productAvailable !== 'true') return 'sold-out';
      const cost = normalize(card.dataset.creditCost);
      if (cost !== '0' && enough(balance, cost)) return 'redeemable';
      return 'other';
    };

    const render = (rawBalance) => {
      const balance = normalize(rawBalance);
      const buckets = { redeemable: [], other: [], 'sold-out': [] };
      cards.forEach((card) => buckets[groupFor(card, balance)].push(card));
      Object.values(buckets).forEach((bucket) => bucket.sort((a, b) => originalOrder.get(a) - originalOrder.get(b)));
      root.querySelectorAll('[data-credit-group]').forEach((group) => {
        const key = group.dataset.creditGroup;
        const grid = group.querySelector('[data-credit-group-grid]');
        buckets[key].forEach((card) => grid.append(card));
        group.querySelector('[data-credit-group-count]').textContent = String(buckets[key].length);
        group.hidden = buckets[key].length === 0;
      });
      groups.hidden = false;
      source.hidden = true;
      root.querySelectorAll('[data-cartune-credit-redeem]').forEach((button) => {
        const canRedeem = enough(balance, normalize(button.dataset.creditCost));
        button.disabled = !canRedeem;
        const card = button.closest('[data-cartune-credit-product]');
        const more = card?.querySelector('[data-cartune-credit-more]');
        if (more) {
          more.hidden = false;
          more.dataset.canRedeem = String(canRedeem);
          more.textContent = canRedeem ? root.dataset.purchaseWithCreditsLabel : more.dataset.moreCreditsLabel;
        }
      });
    };

    document.addEventListener('cartune:credit-balance', (event) => render(event.detail?.count || '0'));
    render(window.__cartuneCreditBalance || '0');

    root.addEventListener('click', (event) => {
      const action = event.target.closest('[data-cartune-credit-more]');
      if (!action) return;
      if (action.dataset.canRedeem === 'true') {
        action.closest('[data-cartune-credit-product]')?.querySelector('.ct-credit-product__redeem-form')?.requestSubmit();
        return;
      }
      window.location.assign(action.dataset.membershipUrl || '/pages/membership');
    });

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('.ct-credit-product__redeem-form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[data-cartune-credit-redeem]');
      const error = form.querySelector('[data-cartune-credit-error]');
      const cost = normalize(button?.dataset.creditCost);
      if (!enough(window.__cartuneCreditBalance || '0', cost)) { if (error) error.textContent = root.dataset.insufficientMessage || ''; return; }
      button.disabled = true;
      if (error) error.textContent = '';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('cart');
        window.location.assign('/checkout');
      } catch {
        button.disabled = false;
        if (error) error.textContent = root.dataset.checkoutErrorMessage || '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-account"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateCreditUnits = (count) => {
      const normalized = String(count ?? window.__cartuneCreditBalance ?? '0');
      document.querySelectorAll('[data-cartune-credit-unit]').forEach((element) => {
        const noun = normalized === '1' ? element.dataset.creditSingular : element.dataset.creditPlural;
        if (noun) element.textContent = noun;
      });
    };

    document.addEventListener('cartune:credit-balance', (event) => updateCreditUnits(event.detail?.count));
    updateCreditUnits();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ct-faq').forEach((section) => {
    const openButton = section.querySelector('[data-ct-savings-open]');
    const dialog = section.querySelector('[data-ct-savings-dialog]');
    const closeButton = section.querySelector('[data-ct-savings-close]');
    if (!openButton || !dialog || !closeButton) return;

    openButton.addEventListener('click', () => dialog.showModal());
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => openButton.focus());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-header-tab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    window.__cartuneCreditSync?.destroy?.();

    const controller = new AbortController();
    const countKeys = ['availableUsagesData', 'availableUsages', 'available', 'remainingUsages', 'remaining', 'balance', 'count', 'credits'];
    const nameKeys = ['membershipName', 'displayName', 'name', 'title', 'label'];
    const sizeImpactHandlers = new WeakMap();
    const sizeInputSelector = ".variant-option--buttons input[type='radio'][data-option-name='Size' i]";

    const normalizeCount = (value) => {
      const match = String(value ?? '').trim().match(/^-?\d+/);
      if (!match || match[0].startsWith('-')) return null;
      return match[0].replace(/^0+(?=\d)/, '');
    };

    const isEnough = (balance, cost) => {
      try { return BigInt(balance) >= BigInt(cost); } catch { return false; }
    };

    const updatePreviewProducts = (balance) => {
      let visibleCount = 0;
      document.querySelectorAll('[data-cartune-credit-preview-card]').forEach((card) => {
        const qualifies = isEnough(balance, card.dataset.creditCost || '0');
        card.hidden = !qualifies;
        if (qualifies) visibleCount += 1;
      });
      document.querySelectorAll('[data-cartune-credit-preview-empty]').forEach((element) => { element.hidden = visibleCount > 0; });
    };

    const updateCreditDisplay = (value) => {
      const normalized = normalizeCount(value);
      if (normalized == null) return;
      window.__cartuneCreditBalance = normalized;
      document.querySelectorAll('[data-cartune-credit-count]').forEach((element) => {
        if (element.textContent !== normalized) element.textContent = normalized;
      });
      document.querySelectorAll('[data-cartune-credit-pill-noun]').forEach((element) => {
        const pill = element.closest('[data-cartune-credit-ready]');
        const noun = normalized === '1' ? pill?.dataset.creditSingular : pill?.dataset.creditPlural;
        if (noun && element.textContent !== noun) element.textContent = noun;
      });
      document.querySelectorAll('[data-cartune-credit-preview-noun]').forEach((element) => {
        const noun = normalized === '1' ? element.dataset.creditSingular : element.dataset.creditPlural;
        if (noun && element.textContent !== noun) element.textContent = noun;
      });
      document.querySelectorAll('[data-cartune-credit-ready]').forEach((element) => { element.hidden = false; });
      updatePreviewProducts(normalized);
      document.dispatchEvent(new CustomEvent('cartune:credit-balance', { detail: { count: normalized } }));
    };

    const mountHeaderItems = () => {
      const membershipItems = document.querySelector('.ct-membership-header-tab');
      const centerWordmark = document.querySelector('.ct-header-center-wordmark');
      const creditDialog = document.querySelector('[data-cartune-credit-dialog]');
      const headerRow = document.querySelector('#header-component .header__row--top');
      const headerMenu = document.querySelector('#header-component .header__column--left header-menu');
      const desktopSearch = document.querySelector('#header-component .header__column--right > search-button.search-action--hidden-on-drawer');
      const headerActions = document.querySelector('#header-component .header__column--right header-actions');
      if (membershipItems && headerActions && membershipItems.nextElementSibling !== headerActions) headerActions.before(membershipItems);
      if (centerWordmark && headerRow && centerWordmark.parentElement !== headerRow) headerRow.append(centerWordmark);
      if (creditDialog && creditDialog.parentElement !== document.body) document.body.append(creditDialog);
      if (window.matchMedia('(min-width: 980px)').matches && desktopSearch && headerMenu && desktopSearch.previousElementSibling !== headerMenu) headerMenu.after(desktopSearch);
    };

    const findCountInData = (value, depth = 0, seen = new Set()) => {
      if (value == null || depth > 7) return null;
      if (Array.isArray(value)) {
        for (const item of value) {
          const count = findCountInData(item, depth + 1, seen);
          if (count != null) return count;
        }
        return null;
      }
      if (typeof value !== 'object' || seen.has(value)) return null;
      seen.add(value);
      const name = nameKeys.map((key) => value[key]).find((candidate) => typeof candidate === 'string');
      if (name?.trim().toLowerCase().includes('cartune credit')) {
        for (const key of countKeys) {
          const count = normalizeCount(value[key]);
          if (count != null) return count;
        }
      }
      for (const nestedValue of Object.values(value)) {
        const count = findCountInData(nestedValue, depth + 1, seen);
        if (count != null) return count;
      }
      return null;
    };

    const readLiquidData = () => {
      try {
        if (typeof liquidData === 'undefined') return null;
        return findCountInData([liquidData.punchcardsProd, liquidData.punchcardsDev]);
      } catch { return null; }
    };

    const readCustomerCardsDom = () => {
      const cards = document.querySelectorAll('.cc_cardbox.punchcard, [class*="punchcard"], [data-punchcard]');
      for (const card of cards) {
        const name = card.querySelector('.membershipName, [class*="membershipName"], [data-membership-name]')?.textContent?.trim().toLowerCase();
        if (!name?.includes('cartune credit')) continue;
        const countElement = card.querySelector('.availableUsagesData, [class*="availableUsages"], [data-available-usages], [data-credit-count]');
        const count = normalizeCount(countElement?.textContent);
        if (count != null) return count;
      }
      return null;
    };

    const syncCustomerCardsBalance = () => {
      const count = readCustomerCardsDom() ?? readLiquidData();
      if (count != null) updateCreditDisplay(count);
    };

    const syncMembershipPolicyDialogs = () => {
      document.querySelectorAll('.as-cp-modal[role="dialog"]').forEach((modal) => {
        const title = modal.querySelector('.as-modal-title span:not(.as-sr-only)')?.textContent?.trim();
        const message = modal.querySelector('.as-modal-body p');
        const confirmButton = modal.querySelector('.as-modal-footer .as-button_modal-primary');
        if (!title || !message || !confirmButton) return;

        if (title === 'Cancel Subscription') {
          modal.classList.add('ct-membership-policy-modal');
          const cancelMessage = 'Canceling stops future membership renewals. Your unused Cartune Credits will remain available for 30 days from your cancellation date. Any credits not used within those 30 days will expire. If you only need a break, pause your membership instead to keep your credits.';
          if (message.textContent !== cancelMessage) message.textContent = cancelMessage;

          const actions = confirmButton.parentElement;
          if (actions && !actions.querySelector('.ct-appstle-pause-instead')) {
            const pauseInstead = document.createElement('button');
            pauseInstead.type = 'button';
            pauseInstead.className = 'ct-appstle-pause-instead';
            pauseInstead.textContent = 'Pause Instead — Keep Credits';
            pauseInstead.addEventListener('click', () => {
              modal.querySelector('#header-close-button')?.click();
              window.setTimeout(() => {
                const pauseButton = Array.from(document.querySelectorAll('#appstleSubscriptionCustomerPortal button'))
                  .find((button) => button.textContent?.trim() === 'Pause Subscription');
                pauseButton?.click();
              }, 180);
            });
            actions.insertBefore(pauseInstead, confirmButton);
          }
        }

        if (title === 'Pause Subscription') {
          modal.classList.add('ct-membership-policy-modal');
          const pauseMessage = 'Pausing your membership for 30 days keeps your existing Cartune Credits attached to your account and stops the next renewal during the pause. Your membership will resume automatically when the pause ends.';
          if (message.textContent !== pauseMessage) message.textContent = pauseMessage;
          if (confirmButton.textContent?.trim() !== 'Pause for 30 days') confirmButton.textContent = 'Pause for 30 days';
        }
      });
    };

    const syncSizeOptionStates = () => {
      document.querySelectorAll(sizeInputSelector).forEach((input) => {
        const label = input.closest('.variant-option__button-label');
        if (!label || label.classList.contains('ct-size-option--impact')) return;
        label.classList.toggle('ct-size-option--landed', input.checked);
      });
    };

    const playSizeImpact = (input) => {
      const label = input.closest('.variant-option__button-label');
      if (!label) return;

      const fieldset = input.closest('.variant-option--buttons');
      fieldset?.querySelectorAll('.variant-option__button-label').forEach((option) => {
        option.classList.remove('ct-size-option--landed');
      });

      const previousHandler = sizeImpactHandlers.get(label);
      if (previousHandler) label.removeEventListener('animationend', previousHandler);
      label.classList.remove('ct-size-option--impact');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        label.classList.add('ct-size-option--landed');
        return;
      }

      void label.offsetWidth;
      const finishImpact = (event) => {
        if (event.target !== label || event.animationName !== 'ct-size-button-impact') return;
        label.classList.remove('ct-size-option--impact');
        label.classList.add('ct-size-option--landed');
        label.removeEventListener('animationend', finishImpact);
        sizeImpactHandlers.delete(label);
      };
      sizeImpactHandlers.set(label, finishImpact);
      label.addEventListener('animationend', finishImpact);
      label.classList.add('ct-size-option--impact');
    };

    const dialog = document.querySelector('[data-cartune-credit-dialog]');
    document.addEventListener('click', (event) => {
      if (event.target.matches?.(sizeInputSelector)) {
        window.requestAnimationFrame(() => playSizeImpact(event.target));
      }
      const opener = event.target.closest('[data-cartune-credit-dialog-open]');
      if (opener) {
        const targetDialog = document.getElementById(opener.getAttribute('aria-controls')) || dialog;
        if (targetDialog?.showModal) {
          if (!targetDialog.open) targetDialog.showModal();
        } else {
          window.location.assign(opener.dataset.creditShopUrl || '/collections/all?view=credits');
        }
      }
      if (event.target.closest('[data-cartune-credit-dialog-close]')) dialog?.close();
      if (event.target === dialog) dialog?.close();
    }, { signal: controller.signal });

    let frameId = 0;
    const scheduleSync = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(() => {
        frameId = 0;
        mountHeaderItems();
        syncCustomerCardsBalance();
        syncMembershipPolicyDialogs();
        syncSizeOptionStates();
      });
    };
    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    const intervalId = window.setInterval(scheduleSync, 2000);
    const onPageShow = () => scheduleSync();
    const onVisibilityChange = () => { if (document.visibilityState === 'visible') scheduleSync(); };
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('visibilitychange', onVisibilityChange);
    document.addEventListener('shopify:section:load', scheduleSync);
    scheduleSync();

    window.__cartuneCreditSync = { destroy() { controller.abort(); observer.disconnect(); window.clearInterval(intervalId); if (frameId) window.cancelAnimationFrame(frameId); window.removeEventListener('pageshow', onPageShow); document.removeEventListener('visibilitychange', onVisibilityChange); document.removeEventListener('shopify:section:load', scheduleSync); } };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-progress"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'ct_membership_selection';

    const readSelection = () => {
      try {
        return JSON.parse(localStorage.getItem(storageKey));
      } catch (storageError) {
        return null;
      }
    };

    const updateIndicator = (indicator) => {
      const selection = readSelection();
      const hasCustomer = indicator.dataset.customer === 'true';
      const hasCompleteProfile = indicator.dataset.profileComplete === 'true';
      const currentStep = !selection ? 1 : hasCustomer && hasCompleteProfile ? 3 : 2;
      const progress = currentStep === 1 ? '16.66%' : currentStep === 2 ? '50%' : '83.33%';
      indicator.style.setProperty('--progress', progress);
      const progressBar = indicator.querySelector('[data-ct-progress-bar]');
      if (progressBar) progressBar.setAttribute('aria-valuenow', String(currentStep));
      indicator.querySelectorAll('[data-ct-step]').forEach((step) => {
        const stepNumber = Number(step.dataset.ctStep);
        step.classList.toggle('is-complete', stepNumber < currentStep);
        step.classList.toggle('is-active', stepNumber === currentStep);
        if (stepNumber === currentStep) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
    };

    const updateAll = () => {
      const update = () => document.querySelectorAll('[data-ct-progress]').forEach(updateIndicator);
      if (document.startViewTransition) document.startViewTransition(update);
      else update();
    };

    document.addEventListener('ct:membership-update', updateAll);
    updateAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-tiers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'ct_membership_selection';

    const saveSelection = (button) => {
      const selection = {
        variantId: button.dataset.variantId,
        planId: button.dataset.planId,
        title: button.dataset.title,
        price: button.dataset.price
      };
      try {
        localStorage.setItem(storageKey, JSON.stringify(selection));
      } catch (storageError) {
        // Keep the current interaction working when browser storage is blocked.
      }
      document.dispatchEvent(new CustomEvent('ct:membership-update', { detail: selection }));
    };

    document.querySelectorAll('[data-ct-tier-selector]').forEach((selector) => {
      const buttons = Array.from(selector.querySelectorAll('[data-ct-tier]'));
      const choices = selector.querySelector('.ct-tier-form__choices');
      const dots = Array.from(selector.querySelectorAll('[data-ct-tier-dot]'));
      const variantInput = selector.querySelector('[data-ct-variant-input]');
      const planInput = selector.querySelector('[data-ct-plan-input]');
      const summaryTitle = selector.querySelector('[data-ct-summary-title]');
      const summaryPrice = selector.querySelector('[data-ct-summary-price]');
      const flowSummary = selector.querySelector('[data-ct-flow-summary]');
      const profileNote = selector.querySelector('[data-ct-profile-note]');
      const form = selector.querySelector('form.ct-tier-form');
      const error = selector.querySelector('[data-ct-checkout-error]');
      const hasActiveSubscription = selector.dataset.activeSubscription === 'true';
      const impactHandlers = new WeakMap();
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let selectionLocked = false;
      let selectedButton = null;
      let paginationFrame;

      const applySelection = (button, persist = true) => {
        buttons.forEach((item) => {
          item.classList.remove('ct-tier--selected');
          item.setAttribute('aria-pressed', 'false');
          const label = item.querySelector('.ct-tier__select');
          if (label) label.textContent = selector.dataset.selectLabel;
        });
        button.classList.add('ct-tier--selected');
        button.setAttribute('aria-pressed', 'true');
        if (variantInput) variantInput.value = button.dataset.variantId;
        if (planInput) planInput.value = button.dataset.planId;
        if (summaryTitle) summaryTitle.textContent = button.dataset.title;
        if (summaryPrice) summaryPrice.textContent = button.dataset.price;
        if (flowSummary) flowSummary.hidden = false;
        if (profileNote) profileNote.hidden = false;
        const selectedLabel = button.querySelector('.ct-tier__select');
        if (selectedLabel) selectedLabel.textContent = selector.dataset.selectedLabel;
        selectedButton = button;
        if (persist) saveSelection(button);
      };

      const setActiveDot = (activeIndex) => {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('ct-tier-form__dot--active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const updatePagination = () => {
        if (!choices || !dots.length) return;
        const choicesRect = choices.getBoundingClientRect();
        const viewportCenter = choices.scrollLeft + (choices.clientWidth / 2);
        let activeIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        buttons.forEach((button, index) => {
          if (button.disabled) return;
          const buttonRect = button.getBoundingClientRect();
          const buttonCenter = buttonRect.left - choicesRect.left + choices.scrollLeft + (buttonRect.width / 2);
          const distance = Math.abs(buttonCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        setActiveDot(activeIndex);
        const centeredButton = buttons[activeIndex];
        if (mobileQuery.matches && !selectionLocked && centeredButton && !centeredButton.disabled && centeredButton !== selectedButton) {
          applySelection(centeredButton);
        }
      };

      if (choices && dots.length) {
        dots.forEach((dot, index) => dot.addEventListener('click', () => {
          const target = buttons[index];
          if (!target || target.disabled) return;
          setActiveDot(index);
          if (mobileQuery.matches && !selectionLocked && target !== selectedButton) {
            applySelection(target);
          }
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }));

        choices.addEventListener('scroll', () => {
          cancelAnimationFrame(paginationFrame);
          paginationFrame = requestAnimationFrame(updatePagination);
        }, { passive: true });
        window.addEventListener('resize', updatePagination);
      }

      const playImpact = (button) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const previousHandler = impactHandlers.get(button);
        if (previousHandler) button.removeEventListener('animationend', previousHandler);
        button.classList.remove('ct-tier--impact');
        void button.offsetWidth;
        const finishImpact = (event) => {
          if (event.target !== button || event.animationName !== 'ct-tier-card-impact') return;
          button.classList.remove('ct-tier--impact');
          button.removeEventListener('animationend', finishImpact);
          impactHandlers.delete(button);
        };
        impactHandlers.set(button, finishImpact);
        button.addEventListener('animationend', finishImpact);
        button.classList.add('ct-tier--impact');
      };

      buttons.forEach((button, index) => {
        button.addEventListener('pointerenter', (event) => {
          if (button.disabled || selectionLocked || mobileQuery.matches || event.pointerType === 'touch') return;
          if (button !== selectedButton) applySelection(button);
        });
        button.addEventListener('click', () => {
          if (button.disabled) return;
          applySelection(button);
          playImpact(button);
          if (mobileQuery.matches) {
            setActiveDot(index);
            button.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
          selectionLocked = true;
          selector.setAttribute('data-ct-selection-locked', 'true');
        });
      });

      let storedSelection;
      try {
        storedSelection = JSON.parse(localStorage.getItem(storageKey));
      } catch (storageError) {
        storedSelection = null;
      }
      const storedButton = storedSelection ? buttons.find((button) => button.dataset.variantId === storedSelection.variantId && !button.disabled) : null;
      if (storedButton) applySelection(storedButton);
      if (storedButton && choices && mobileQuery.matches) {
        choices.scrollLeft = Math.max(0, storedButton.offsetLeft - 9);
      }
      updatePagination();

      if (form && selector.dataset.customer === 'true' && !hasActiveSubscription) {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const submitter = form.querySelector('[type="submit"]');
          if (submitter) submitter.setAttribute('aria-busy', 'true');
          if (error) error.hidden = true;
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new FormData(form)
            });
            if (!response.ok) throw new Error('checkout');
            window.location.assign(`${window.Shopify.routes.root}checkout`);
          } catch (checkoutError) {
            if (error) {
              error.textContent = selector.dataset.errorMessage;
              error.hidden = false;
            }
            if (submitter) submitter.removeAttribute('aria-busy');
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
